module.exports = __webpack_public_path__ + "static/lighting-table-basic-878181dec706500d3742fb7a74798cbd.png";